module.exports = __webpack_public_path__ + "img/group2.2aff7bbb.png";